import tw, { theme } from 'twin.macro'
import Tabs from '@material-ui/core/Tabs'
import styled from 'styled-components'

const TabsContainer = styled(Tabs)`
  ${tw`text-h5`}
  margin: 0 4px;
  margin-top: 16px;
  @media (min-width: ${theme`screens.md`}) {
    max-width: 768px;
    margin: 0 auto;
    margin-top: 20px;
  }
`

export default TabsContainer
